<template>
  <div
    v-if="product?.short_description?.html"
    class="giftcard__product-short-description"
  >
    <span class="giftcard__product-short-description-text">
      {{ product?.short_description?.html }}
    </span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  product?: {
    short_description?: {
      html?: string
    }
  }
}>()
</script>

<style>
  @import url("~layers/app/components/Product/GiftCard/Heading.css");
</style>
